<template>
  <v-app-bar fixed class="hpo_color">
    <v-app-bar-nav-icon @click.stop="handleDrawerToggle" class="hpo_color"></v-app-bar-nav-icon>
    <v-spacer></v-spacer>
     <!-- Language Selector -->
    <language-selector></language-selector>
    
    <v-menu
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
      class="pr-3"
    >
      <template v-slot:activator="{ on }">
        <v-btn large text v-on="on">
          <v-label>{{userName}}</v-label>
          <v-avatar size="30px">
            <img src="/static/avatar/avatar.png" alt="HPO" />
          </v-avatar>
        </v-btn>
      </template>
      <v-list class="pa-0">
        <v-list-item
          v-for="(item,index) in items"
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          @click="item.click"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="index"
        >
          <v-list-item-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
// import NotificationList from "@/components/widgets/list/NotificationList";
import Util from "@/util";
import LanguageSelector from "@/components/general/LanguageSelector";
// import { mapState } from "vuex";
// import moment from "moment";
import _ from "lodash";
export default {
  name: "app-toolbar",
  components: {
    LanguageSelector
  },
  data: () => ({
    items: [
      {
        icon: "manage_accounts",
        href: "/tai-khoan",
        title: "Tài khoản",
        click: e => {
          this.$router.push({ path: "tai-khoan" });
        }
      },
      {
        icon: "logout",
        href: "#",
        title: "Đăng xuất",
        click: () => {
          window.getApp.$emit("APP_LOGOUT");
        }
      }
    ]
  }),
  computed: {
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },
    userName() {
      return this.$store.state.authentication.user.username;
    },
  },
  methods: {
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    }
  },
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>
